"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
function e(e) {
  return e && "object" == _typeof(e) && "default" in e ? e : {
    "default": e
  };
}
var t = e(require("polished/lib/helpers/em")),
  a = {
    xsmall: 0,
    small: 480,
    medium: 768,
    large: 1024,
    large1200: 1200,
    xlarge: 1440,
    xxlarge: 1920
  },
  n = Object.keys(a),
  u = {
    xsmall: t["default"]("0px"),
    small: t["default"]("480px"),
    medium: t["default"]("768px"),
    large: t["default"]("1024px"),
    large1200: t["default"]("1200px"),
    xlarge: t["default"]("1440px"),
    xxlarge: t["default"]("1920px"),
    up: function up(e) {
      return "@media (min-width:".concat("number" == typeof a[e] ? a[e] : e, "px)");
    },
    down: function down(e) {
      return "@media (max-width:".concat(("number" == typeof a[e] ? a[e] : e) - .05, "px)");
    },
    between: function between(e, t) {
      var u = n.indexOf(t);
      return "@media (min-width:".concat("number" == typeof a[e] ? a[e] : e, "px) and ") + "(max-width:".concat((-1 !== u && "number" == typeof a[n[u]] ? a[n[u]] : t) - .05, "px)");
    },
    values: a,
    defaultMatchUp: function defaultMatchUp(e, t) {
      return {
        defaultMatches: t >= e
      };
    },
    defaultMatchDown: function defaultMatchDown(e, t) {
      return {
        defaultMatches: t < e
      };
    },
    defaultMatchBetween: function defaultMatchBetween(e, t, a) {
      return {
        defaultMatches: a >= e && a < t
      };
    }
  };
exports.breakpoints = u;